import { forwardRef } from "react"


const Button = forwardRef(({ children, className = '', ...rest }, ref) => {
    return <button ref={ref} className={`btn ${className}`} {...rest}>
        {children}
    </button>
});

export { Button }